<template>
    <v-container>
        <v-stepper v-model="step">
            <v-stepper-header>
                <v-stepper-step step="1" :complete="step > 1">
                    Verificación
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2" :complete="step > 2">
                    Información
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">
                    Completado !
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1" class="height">
                    <v-row align="center" justify="center">
                        <v-col cols="12">
                            <v-list disabled>
                                <v-list-item
                                    v-for="(item, index) in cart"
                                    :key="index"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="azul--text">
                                            {{ getDesc(item.product) }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <span class="azul--text">
                                            Cantidad: {{ item.cantidad }}
                                        </span>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                    <v-btn
                        color="grey"
                        @click="$router.replace({ name: 'Carrito' })"
                    >
                        <v-icon>mdi-keyboard-return</v-icon>
                    </v-btn>
                    <v-btn color="green" @click="next">
                        Siguiente
                    </v-btn>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-card elevation="0">
                        <v-container class="text-center azul--text">
                            <h3 class="py-3 my-3">
                                La fecha de entrega se le informará en el
                                momento de facturación
                            </h3>
                            <h3 class="py-3 my-3">
                                Las condiciones de pago serán las utilizadas
                                habitualmente entre el cliente y la empresa
                            </h3>
                        </v-container>
                    </v-card>
                    <v-btn color="grey" @click="previous">
                        <v-icon>mdi-keyboard-return</v-icon>
                    </v-btn>
                    <v-btn
                        :disabled="loading"
                        color="green"
                        @click="enviarPedido"
                    >
                        Finalizar Pedido
                    </v-btn>
                </v-stepper-content>
                <v-stepper-content step="3">
                    <v-container class="pt-5 mt-5">
                        <v-row align="center" justify="center">
                            <v-card
                                v-if="!hideSuccess"
                                max-width="450px"
                                color="green lighten-1"
                            >
                                <v-card-title>
                                    ¡ Listo ! Recibimos tu pedido :)
                                </v-card-title>
                            </v-card>
                            <v-card
                                v-if="hideSuccess"
                                max-width="450px"
                                color="red lighten-1"
                            >
                                <v-card-title>
                                    Ha ocurrido un error :(
                                    <br />
                                    Inténtelo nuevamente
                                </v-card-title>
                            </v-card>
                        </v-row>

                        <v-row>
                            <v-btn
                                color="grey"
                                @click="$router.replace({ name: 'Home' })"
                            >
                                Volver a inicio
                            </v-btn>
                        </v-row>
                    </v-container>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import gd from '../utils/getDesc';

export default {
    data: () => ({
        step: 1,
        hideSuccess: false,
        loading: false
    }),
    computed: {
        ...mapState('products', ['cart'])
    },
    methods: {
        ...mapActions('pedidos', ['sendPedido']),
        ...mapMutations('products', ['CLEAR_CART']),

        getDesc: gd,

        async enviarPedido() {
            this.loading = true;
            const { error } = await this.sendPedido({
                cartItems: this.cart
            });
            if (error) {
                this.hideSuccess = true;
                this.next();
            } else {
                this.CLEAR_CART();
                this.next();
            }
            this.loading = false;
        },
        next() {
            this.step += 1;
        },
        previous() {
            this.step -= 1;
        }
    }
};
</script>
